export default __webpack_public_path__ + "static/01_V1@2x-94789be4802a99e1cd6a82b091815774.png";